'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _icon = require('../../icon');

var _icon2 = _interopRequireDefault(_icon);

var _style = require('./style.css');

var _style2 = _interopRequireDefault(_style);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var cx = _bind2.default.bind(_style2.default);

var Navbar = function Navbar(_ref) {
  var onPreviousClick = _ref.onPreviousClick,
      onNextClick = _ref.onNextClick;
  return _react2.default.createElement('div', {
    className: cx('xsui-datepicker-navbar')
  }, _react2.default.createElement(_icon2.default, {
    name: 'chevron-reverse',
    hoverable: true,
    onClick: function onClick() {
      return onPreviousClick();
    }
  }), _react2.default.createElement(_icon2.default, {
    name: 'chevron',
    hoverable: true,
    onClick: function onClick() {
      return onNextClick();
    }
  }));
};

Navbar.propTypes = {
  onPreviousClick: _propTypes2.default.func.isRequired,
  onNextClick: _propTypes2.default.func.isRequired
};
exports.default = Navbar;